import { Stack } from "expo-router";
import { Platform } from "react-native";
import { HeaderButton } from "~/components/HeaderButton";
import { useDismiss } from "~/providers/DismissProvider";
import { useTheme } from "~/providers/ThemeProvider";

export default function ResetPasswordLayout() {
    const { dark } = useTheme();
    const { handleDismiss } = useDismiss();

    return (
        <Stack
            screenOptions={{
                headerTransparent: true,
                headerLeft: () => <HeaderButton onPress={handleDismiss} title="Back" icon="chevron-left" />,
                title: "",
                statusBarStyle: Platform.select({ android: dark ? "light" : "dark", default: undefined }),
            }}
        />
    );
}
